export const OVERALLPERFORMANCESALL_REQUEST = "OVERALLPERFORMANCESALL_REQUEST";
export const OVERALLPERFORMANCESALL_SUCCESS = "OVERALLPERFORMANCESALL_SUCCESS";
export const OVERALLPERFORMANCESALL_FAIL = "OVERALLPERFORMANCESALL_FAIL";